import React, { Component } from "react"
import { Modal, Button } from "antd"
import "./Index.scss"

export default class Index extends Component {

  handleOk() {
    this.props.onOk(this.props.editData)
  }

  render() {
    return (
      <Modal
        {...this.props}
        title={<div className="cmodal-title">
        <i className="dna-icon" />{this.props.title}<i className="dna-icon" /></div>}
        footer={[
          <Button key="submit" type="primary" size="large" onClick={() => this.handleOk()}>
            {this.props.okText || "确定"}
          </Button>
        ]}
      >
        {this.props.children}
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/normal/CModal/index.js